import React from 'react';
import {
  viPlayCircleOutline,
} from 'vibeguide';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import rootColor from '../../../sass/color.scss';
import CellTooltip from './CellTooltip';
import VibeIcon from '../../VibeIcon/VibeIcon';
import './AudioCell.scss';

function VisualCell({
  className,
  disabled,
  id,
  name,
  showDisplayPlayer,
  color,
}) {
  return (
    <div className={classNames('AudioCell', className)}>
      <VibeIcon
        icon={viPlayCircleOutline}
        color={color}
        hoverColor={!disabled
          ? rootColor.primary
          : color}
        size={16}
        tooltip="Preview Visual"
        tooltipProps={{
          placement: 'top',
        }}
        disabled={disabled}
        onClick={(e) => showDisplayPlayer(e, id)}
      />

      <CellTooltip title={name}>
        <div className="audio-name">
          {name}
        </div>
      </CellTooltip>
    </div>
  );
}

VisualCell.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  showDisplayPlayer: PropTypes.func,
  color: PropTypes.string,
  // disabled: PropTypes.bool,
};

VisualCell.defaultProps = {
  className: '',
  name: '',
  showDisplayPlayer: () => {},
  color: '',
  // disabled: false,
};

export default VisualCell;
